export const HUD3_MODES = {
  TRANSCRIPT: "transcript",
  DIFFERENTIAL: "differential",
  PEARLS: "pearls",
  DIAGNOSTICS: "diagnostics",
  TREATMENT: "treatment",
  DISCHARGE: "discharge",
  DOCUMENTATION: "documentation",
};

export const HUD3_MODE_ORDER = [
  HUD3_MODES.TRANSCRIPT,
  HUD3_MODES.DIFFERENTIAL,
  HUD3_MODES.PEARLS,
  HUD3_MODES.DIAGNOSTICS,
  HUD3_MODES.TREATMENT,
  HUD3_MODES.DISCHARGE,
  HUD3_MODES.DOCUMENTATION,
];

export const HUD3_MODE_LABELS = {
  [HUD3_MODES.TRANSCRIPT]: "Transcript",
  [HUD3_MODES.DIFFERENTIAL]: "Differential",
  [HUD3_MODES.PEARLS]: "Pearls",
  [HUD3_MODES.DIAGNOSTICS]: "Diagnostics",
  [HUD3_MODES.TREATMENT]: "Treatment",
  [HUD3_MODES.DISCHARGE]: "Discharge Plan",
  [HUD3_MODES.DOCUMENTATION]: "Documentation",
};

export function isHud3Mode(value) {
  return HUD3_MODE_ORDER.includes(value);
}

export function nextHud3Mode(current) {
  const i = HUD3_MODE_ORDER.indexOf(current);
  const idx = i < 0 ? 0 : (i + 1) % HUD3_MODE_ORDER.length;
  return HUD3_MODE_ORDER[idx];
}

export function prevHud3Mode(current) {
  const i = HUD3_MODE_ORDER.indexOf(current);
  const idx = i < 0 ? 0 : (i - 1 + HUD3_MODE_ORDER.length) % HUD3_MODE_ORDER.length;
  return HUD3_MODE_ORDER[idx];
}
